/* eslint-disable prefer-destructuring */
var chineseReg = new RegExp("[\u4E00-\uFA29\uE7C7-\uE7F3]+", 'g');
var wordReg = new RegExp('[A-Za-z]{1,4}');
var colors = ['#2f54eb', '#722ed1', '#eb2f96', '#1890ff', '#13c2c2', '#52c41a', '#a0d911', '#fadb14', '#f5222d', '#fa8c16', '#612500', '#5c0011'];
export var getAbbrName = function getAbbrName(name) {
  var result = '';
  var m = (name || '').match(chineseReg);

  if (m && m.length !== 0) {
    result = m[0];

    if (result && result.length > 2) {
      result = result.substring(result.length - 2, result.length);
    }
  }

  if (!result) {
    m = (name || '').match(wordReg);

    if (m && m.length !== 0) {
      result = m[0];
    }
  }

  if (!result) {
    result = name.substr(0, 1);
  }

  return result;
};
export var hashCode = function hashCode(str) {
  str = str || '';
  return str.split('').reduce(function (a, b) {
    a = (a << 5) - a + b.charCodeAt(0);
    return a & a;
  }, 0);
};
export var getColor = function getColor(name) {
  var idx = Math.abs(hashCode(name)) % colors.length;
  var color = colors[idx];
  return color;
};
//# sourceMappingURL=util.js.map
